import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/authContext';

const PublicRoute = ({ children }) => {
  const { userLoggedIn, loading } = useAuth();
  
  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '18px'
      }}>
        Loading...
      </div>
    );
  }
  
  if (userLoggedIn) {
    return <Navigate to="/upload" replace />;
  }
  
  return children;
};

export default PublicRoute;

